import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import {
  DOG_CREATE_URL,
  SINGLE_DOG_DETAILS_URL,
  UPDATE_DOG_DETAILS_URL,
  UPLOAD_FILE,
} from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { getAgencyId } from "../../common/CommonFunctions";
import moment from "moment";
import CustomButtonLoader from "../../CustomComponents/CustomButtonLoader";
import dogImg from "../../../images/dog.png";

export default function CreateNewDog(props) {
  const { enqueueSnackbar } = useSnackbar();
  const {
    toggle,
    userId,
    modal,
    successCallBack,
    selectedDogId = "",
  } = props;
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [detailsLoad, setDetailLoad] = useState(false);
  const [formData, setFormData] = useState({
    dogName: "",
    breed: "",
    color: "",
    DOB: "",
    sex: "",
    dogImageUrl: "",
    dogDescription: "",
  });

  const choosenImage = async (event) => {
    const file = new FormData();
    file.append("file", event.target.files[0]);
    if (!event.target.files[0]) return;
    setImageLoading(true);
    const config = {
      method: "POST",
      url: UPLOAD_FILE,
      headers: authHeader(),
      data: file,
      "content-type": "multipart/form-data",
    };

    try {
      const response = await API(config);
      const { filePath, status } = response.data;
      if (status === "Success") {
        setValues({
          ...values,
          dogImageUrl: filePath,
        });
      }
    } catch (error) {
      console.error(error);
      let { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setImageLoading(false);
    }
  };
  const validationSchema = Yup.object({
    dogName: Yup.string().trim().required("Pet Name is required"),
    breed: Yup.string().trim().required("Breed is required"),
    color: Yup.string().trim().required("Color is required"),
    DOB: Yup.date()
      .max(new Date(), "Invalid Date of Birth")
      .required("Date of Birth is required"),
    sex: Yup.string().trim().required("Gender is required"),
    dogDescription: Yup.string().trim().required("Description is required"),
  });
  const saveFormValues = async (values) => {
    const agencyId = getAgencyId();
    const { dogImageUrl } = formData;
    values.dogImageUrl = dogImageUrl;
    setLoading(true);
    const config = {
      method: selectedDogId ? "PUT" : "POST",
      url: selectedDogId ? UPDATE_DOG_DETAILS_URL : DOG_CREATE_URL,
      data: selectedDogId
        ? { ...values, dogId: parseInt(selectedDogId) }
        : { ...values, agencyId: agencyId, dogRegiesterId: userId },
      headers: authHeader(),
    };

    try {
      const response = await API(config);
      const { status } = response.data;

      if (status === "Success") {
        if (selectedDogId) {
          CustomAlertMessage(
            "Dog Details Updated Successfully!",
            "success",
            enqueueSnackbar
          );
        } else {
          CustomAlertMessage(
            "Created Successfully!",
            "success",
            enqueueSnackbar
          );
        }
      }
      successCallBack();
    } catch (error) {
      let { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };
  //Formik
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    setValues,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => saveFormValues(values),
  });
  const getDogDetails = async () => {
    setDetailLoad(true);
    const config = {
      method: "GET",
      url: SINGLE_DOG_DETAILS_URL,
      headers: authHeader(),
      params: {
        dogId: selectedDogId,
      },
    };
    try {
      const response = await API(config);
      const { data } = response.data;
      const {
        dogName,
        breed,
        color,
        DOB,
        sex,
        dogImageUrl,
        dogDescription,
      } = data;
      setFormData({
        ...formData,
        dogName: dogName,
        breed: breed,
        color: color,
        DOB: DOB,
        sex: sex,
        dogImageUrl: dogImageUrl,
        dogDescription: dogDescription,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setDetailLoad(false);
    }
  };
  useEffect(() => {
    if (selectedDogId) {
      getDogDetails();
    }
  }, [selectedDogId]);

  return (
    <div>
      {detailsLoad && <CustomPageLoading />}
      {imageLoading && <CustomPageLoading />}
      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <Form form="true" onSubmit={handleSubmit}>
          <ModalHeader toggle={toggle}>
            {selectedDogId ? "Update Dog Details" : "Create Dog"}
          </ModalHeader>
          <ModalBody>
            <div className="user-box">
              <img
              alt=""
                value={values.dogImageUrl}
                src={values.dogImageUrl ? values.dogImageUrl : dogImg}
              />
              <p>Dog Profile</p>

              <div className="upload-btn-wrapper">
                <button className="upload-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19.407"
                    height="16.981"
                    viewBox="0 0 19.407 16.981"
                  >
                    <path
                      id="Icon_awesome-camera"
                      data-name="Icon awesome-camera"
                      d="M19.407,6.5V17.412a1.82,1.82,0,0,1-1.819,1.819H1.819A1.82,1.82,0,0,1,0,17.412V6.5A1.82,1.82,0,0,1,1.819,4.676H5.155l.466-1.247a1.817,1.817,0,0,1,1.7-1.179H12.08a1.817,1.817,0,0,1,1.7,1.179l.47,1.247h3.336A1.82,1.82,0,0,1,19.407,6.5Zm-5.155,5.458A4.549,4.549,0,1,0,9.7,16.5,4.552,4.552,0,0,0,14.252,11.954Zm-1.213,0A3.336,3.336,0,1,1,9.7,8.618,3.341,3.341,0,0,1,13.039,11.954Z"
                      transform="translate(0 -2.25)"
                      fill="#d51d1d"
                    />
                  </svg>
                </button>
                <Input type="file" name="dogImageUrl" onChange={choosenImage} />
              </div>
            </div>
            <Row xs="12">
              <Col xs="6">
                <FormGroup>
                  <Label for="dogName">Pet Name</Label>
                  <Input
                    type="text"
                    name="dogName"
                    value={values.dogName}
                    onBlur={handleBlur}
                    invalid={errors.dogName && touched.dogName ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter  Name"
                  />
                  <FormFeedback>
                    {errors.dogName && touched.dogName ? errors.dogName : ""}
                  </FormFeedback>
                </FormGroup>

                <FormGroup>
                  <Label for="color">Color</Label>
                  <Input
                    type="text"
                    name="color"
                    value={values.color}
                    onBlur={handleBlur}
                    invalid={errors.color && touched.color ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter Color"
                  />
                  <FormFeedback>
                    {errors.color && touched.color ? errors.color : ""}
                  </FormFeedback>
                </FormGroup>

                <FormGroup>
                  <Label for="sex">Gender</Label>
                  <Input
                    type="select"
                    name="sex"
                    value={values.sex}
                    onBlur={handleBlur}
                    invalid={errors.sex && touched.sex ? true : false}
                    onChange={handleChange}
                    id=""
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </Input>
                  <FormFeedback>
                    {errors.sex && touched.sex ? errors.sex : ""}
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <Label for="breed">Breed</Label>
                  <Input
                    type="text"
                    name="breed"
                    value={values.breed}
                    onBlur={handleBlur}
                    invalid={errors.breed && touched.breed ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter Breed"
                  />
                  <FormFeedback>
                    {errors.breed && touched.breed ? errors.breed : ""}
                  </FormFeedback>
                </FormGroup>

                <FormGroup>
                  <Label for="DOB">Date of Birth</Label>
                  <Input
                    type="date"
                    name="DOB"
                    value={moment(values.DOB).format("YYYY-MM-DD")}
                    onBlur={handleBlur}
                    invalid={errors.DOB && touched.DOB ? true : false}
                    onChange={handleChange}
                    placeholder="Date of Birth"
                    id=""
                  />
                  <FormFeedback>
                    {errors.DOB && touched.DOB ? errors.DOB : ""}
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for="dogDescription">Description</Label>
                  <Input
                    type="text"
                    name="dogDescription"
                    value={values.dogDescription}
                    onBlur={handleBlur}
                    invalid={
                      errors.dogDescription && touched.dogDescription
                        ? true
                        : false
                    }
                    onChange={handleChange}
                    id=""
                    placeholder="Enter Description"
                  />
                  <FormFeedback>
                    {errors.dogDescription && touched.dogDescription
                      ? errors.dogDescription
                      : ""}
                  </FormFeedback>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" block>
              {loading && <CustomButtonLoader />}
              {selectedDogId ? "Update" : "Add"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
}
